/** 刷新token的时长4*60*60 */
export const REFRESH_SECONDS = 14400;

/** 发送短信时长 */
export const SEND_MSG_SECONDS = 60;

/** 秒转为毫秒进制 */
export const M_TO_MS_SCALE = 1000;

/** from参数标识 */
export const OPEN_TYPE = 'h3yun_open_type';

/** 登录时切换的企业 */
export const LOGIN_ENGINE_CODE = 'login_engine_code';

/** 登录后跳转 */
export const LOGIN_REDIRECT_URI = 'login_redirect_uri';

/** 登录时选择的token */
export const LOGIN_TOKEN = 'login_token';

/** 登录时选择的企业信息 */
export const LOGIN_CORPS = 'login_corps';

/** 登录时微信code码 */
export const LOGIN_WECHAT_CODE = 'login_wechat_code';

/** 登录页记录所选页面(防止刷新重置) */
export const LOGIN_PAGE_STATE = 'login_page_state';

/** 发送注册短信倒计时 */
export const AUTO_REGISTER_TIMER = 'auto_register_timer';

/** 注册时选择的token */
export const REGISTER_TOKEN = 'register_token';

/** 注册时选择的企业信息 */
export const REGISTER_CORPS = 'register_corps';

/** 注册时携带的邀请码 */
export const RECOMMEND_CODE = 'recommendCode';

/** 注册时携带的要安装的解决方案编码 */
export const SOLUTION_CODE = 'h3_solutionCode';

/** 注册时缓存query的q参数标识 */
export const REGISTER_QUERY_Q_KEY = 'register_query_q_key';

/** 发送重置短信倒计时 */
export const AUTO_RESET_TIMER = 'auto_reset_timer';

/** 发送登录短信倒计时 */
export const AUTO_LOGIN_TIMER = 'auto_login_timer';

/** 发送外部短信倒计时 */
export const AUTO_EXTERNAL_TIMER = 'auto_external_timer';

/** 组织互通相关 */
export const ORG_FROM_PATH = 'org_from_path';

export const ASS_ORG_ENGINE_CODE = 'ass_org_engine_code';

export const ASS_ORG_GUID = 'ass_org_guid';

export const OLD_ORG_FROM_PATH = 'origin_fromPath';

export const OLD_ASS_ORG_ENGINE_CODE = 'associatedOrg_enginecode';

export const OLD_ASS_ORG_GUID = 'associatedOrg_guid';

/** 模板中心相关 */
export const TEMP_CENTER_REDIRECT = 'temp_center_redirect';

/** 注册成功跳转时长 */
export const SUCCESS_REGISTER_SECONDS = 3;

/** 模板体验中心需要用到的参数 */
export const TEMPLATE_EXPERIENCE_PARAMS = 'TEMPLATE_EXPERIENCE_PARAMS';

/** 来源地址 */
export enum FromPathEnum {
    /** 组织互通 */
    ASS_ORG = 'ass_org',
    /** 组织互通(v2) */
    OLD_ASS_ORG = 'associatedOrganization',
    /** 阿里市场 */
    ALIYUN_MARKET = 'AliyunMarket',
    /** 模板中心 */
    TMP_CENTER = 'templateCenter',
    /** 应用中心 */
    APP_CENTER = 'AppCenter',
    /** 注册 */
    REGISTER = 'Register',
    ENGINE_CONNECTION = 'EngineConnection',
    /** 推荐官相关 */
    RECOMMENDATION = 'Recommendation',
    /** 推荐官注册 */
    RECOMMENDATION_APPLY = 'H3-Recommendation-Apply',
    /** 服务商来源注册 */
    PROVIDER_REGISTER = 'H3-AppCenter-IFrame',
}

/** 注册类型 */
export enum RegisterType {
    H3 = 'H3',
    DING_TALK = 'DingTalk',
    WE_CHAT = 'WeChat',
    APP = 'App',
    ENGINE_CONNECTION = 'EngineConnection',
}

/** 重定向类型 */
export enum RedirectType {
    /** 模板中心 */
    TEMP_CENTER = '1',
    /** 官网 */
    OFFICIAL_WEBSITE = '2',
}
